import React from "react";

type Props = {
    name: string;
};

/** The app's own Material Symbols font — decorative only, the text beside it carries the meaning. */
export const DailyIcon: React.FC<Props> = ({ name }) => (
    <span className="material-symbols-outlined daily-icon" aria-hidden="true">{name}</span>
);
